
import React, { FC } from 'react';
import styled, { css } from '@emotion/native';
import { Text } from '@components/1-atoms';
import { ListItem as ListItemBase, } from '@components/2-molecules';
import _ from 'underscore';
import ProductService from './StatementProductServiceItem';

const Component = styled(ListItemBase)`
  margin-bottom: 0px;
  border-bottom-style: none;
`;


type Props = { data: any; }

const Account: FC<Props> = ({ data, ...props }) => {

    // const ProductsServices = data?.productsServices.length && data?.productsServices.map((productService: any) => {
    //     return (<ProductService data={productService} />);
    // });
    
    return (
        <>
            <Component
                hideLine
                height={45}
                right={<Text>{data.balance.toFixed(2)}</Text>}
            >
                {data.name}
            </Component>
            {/* {ProductsServices */}
        </>
    );
};

export default Account;